import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ApiService } from './api-ws.service';

export interface AvailabilityConfiguration {
    timeout: number;
    defaultState: number;
}

@Injectable({ providedIn: 'root' })
export class AppConfigurationService {
    availabilityConfig$ = new BehaviorSubject<AvailabilityConfiguration>({ timeout: 3000, defaultState: 2 });

    constructor(private readonly apiService: ApiService) { }

    /** Charge la config de manière non bloquante */
    load(): void {
        this.apiService.getConfigurationAvailability()
            .pipe(
                catchError(err => {
                    throw err;
                })
            )
            .subscribe(config => {
                this.availabilityConfig$.next(config);
            });
    }
    getAvailabilityConfig$(): Observable<AvailabilityConfiguration> {
        return this.availabilityConfig$.asObservable();
    }
}